import Vue from "vue";
import Vuex from "vuex";
import de from "element-ui/src/locale/lang/de";
import defaultSettings from '@/settings'

Vue.use(Vuex);

const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings
export default new Vuex.Store({
    //这个就是数据
    state: {
        routes:[],
        config:{},
        user:{},
        sidebar: {
            opened: true,
            withoutAnimation: false
        },
        device: 'desktop',
        size: 'medium',
        showSettings: showSettings,
        tagsView: tagsView,
        fixedHeader: fixedHeader,
        sidebarLogo: sidebarLogo,
        logs: []

    },
    //相当于组件的计算属性
    getters: {
        device: state => state.device,
        sidebar: state => state.sidebar,
        permission_routes: state => state.routes,
        errorLogs: state => state.logs
    },
    //这个里面可以更新state的数据不过是同步的
    mutations:{
        initRoutes(state,data){
            state.routes=data
        },
        config(state,data){
            state.config=data
        },
        user(state,data){
            state.user=data
        },
        TOGGLE_SIDEBAR: state => {
            state.sidebar.opened = !state.sidebar.opened
            state.sidebar.withoutAnimation = false
            /*if (state.sidebar.opened) {
                Cookies.set('sidebarStatus', 1)
            } else {
                Cookies.set('sidebarStatus', 0)
            }*/
        },
        CLOSE_SIDEBAR: (state, withoutAnimation) => {
            //Cookies.set('sidebarStatus', 0)
            state.sidebar.opened = false
            state.sidebar.withoutAnimation = withoutAnimation
        },
        TOGGLE_DEVICE: (state, device) => {
            state.device = device
        },
        SET_SIZE: (state, size) => {
            state.size = size
            //Cookies.set('size', size)
        }
    },
    //异步请求可以在这个里面实现
    actions:{
        toggleSideBar({ commit }) {
            commit('TOGGLE_SIDEBAR')
        },
        closeSideBar({ commit }, { withoutAnimation }) {
            commit('CLOSE_SIDEBAR', withoutAnimation)
        },
        toggleDevice({ commit }, device) {
            commit('TOGGLE_DEVICE', device)
        },
        setSize({ commit }, size) {
            commit('SET_SIZE', size)
        }
    },
    //这个可以引入多个模块
    modules: {}
})